/* import __COLOCATED_TEMPLATE__ from './dialog-body.hbs'; */
/**
## Dialog body

Contextual component used for [Modals](/components/glass/dialog-modal.html),
[Blades](/components/glass/dialog-blade.html), and [Sheets](/components/glass/dialog-sheet.html).

### Parameters
@param {string} [context] Determines the parent context in which this body is shown, which applies appropriate class name bindings.
@param {string} [bodyLayout='DEFAULT'] 'DEFAULT' or 'CENTERED'
**/

import Component from '@ember/component';
import { computed } from '@ember/object';
import { CONTEXT } from '../utils/dialog-actions';
export const BODY_LAYOUT = {
  DEFAULT: 'DEFAULT',
  CENTERED: 'CENTERED'
};

// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  classNames: ['dialog__body'],
  classNameBindings: ['bodyClass'],
  attributeBindings: ['data-test-dialog-body', 'isBladeContext:data-test-blade-body', 'isModalContext:data-test-modal-body'],
  bodyLayout: BODY_LAYOUT.DEFAULT,
  isModalContext: computed('context', function () {
    return this.get('context') === CONTEXT.MODAL;
  }),
  isBladeContext: computed('context', function () {
    return this.get('context') === CONTEXT.BLADE;
  }),
  isBodyLayoutCentered: computed('isModalContext', 'bodyLayout', function () {
    // NB(jlintern): The CENTERED layout might work for blades and sheets, but the only place
    // we know it will be used is MODAL context, so let's restrict it to that for now.
    return this.get('isModalContext') && this.get('bodyLayout') === BODY_LAYOUT.CENTERED;
  }),
  bodyClass: computed('context', function () {
    switch (this.get('context')) {
      case CONTEXT.MODAL:
        return 'dialog--modal__body';
      case CONTEXT.BLADE:
        return 'dialog--blade__body';
      case CONTEXT.SHEET:
        return 'dialog--sheet__body';
      default:
        return '';
    }
  }),
  // wraps the content passed to dialog-body
  contentClass: computed('context', 'isBodyLayoutCentered', function () {
    const classes = [];
    if (this.get('context') === CONTEXT.MODAL) {
      classes.push('dialog--modal__content');
      if (this.get('isBodyLayoutCentered')) {
        classes.push('dialog--modal__content--centered');
      }
    } else if (this.get('context') === CONTEXT.BLADE) {
      classes.push('dialog--blade__content');
    } else if (this.get('context') === CONTEXT.SHEET) {
      classes.push('dialog--sheet__content');
    }
    return classes.join(' ');
  })
});